export default __webpack_public_path__ + "1fc0c8f54515802886559826626d7edc.pdf";